module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-lock2-636ea7b1.svg";